import {Stack, Text} from '@mantine/core';
import React from 'react';

interface RoutineFieldHeaderProps {
  title: string;
  description?: string;
}

/**
 * Shared section header for the Background Agent (Routine) form. Matches the
 * built-in Mantine input label/description styling (`md`/bold title, `md`/dimmed
 * description) so every custom section header lines up with the Name/Description/
 * Instructions inputs.
 */
export default function RoutineFieldHeader({title, description}: RoutineFieldHeaderProps): JSX.Element {
  return (
    <Stack spacing={4}>
      <Text size="md" fw="bold">
        {title}
      </Text>
      {description != null && (
        <Text size="md" c="dimmed">
          {description}
        </Text>
      )}
    </Stack>
  );
}
